module.exports = __webpack_public_path__ + "static/media/Project_Icon.153d4309.svg";